import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gm-loading-spinner-overlay',
  templateUrl: './loading-spinner-overlay.component.html',
  styleUrls: ['./loading-spinner-overlay.component.scss']
})
export class LoadingSpinnerOverlayComponent implements OnInit {

  constructor() {
    //this is kept empty on purpose
   }

  ngOnInit() {
    //this is kept empty on purpose
  }

}
